import React from 'react'; 

const printContext = React.createContext({print:()=>{}});
    
export default printContext;